import { Component, EventEmitter, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GenericResponse } from 'app/models2/commos/generic-response';
import { UpdateData } from 'app/models2/commos/update-data';
import { EquipmentRental } from 'app/models2/rental/equipment-rental';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import { HeaderFilters, HttpService, MenuBreadCrumb, MessageService, TableColumns, TableConfiguration } from 'brainloper-ui';

@Component({
  selector: 'app-rental-equipments',
  templateUrl: './rental-equipments.component.html',
  styleUrls: ['./rental-equipments.component.scss']
})
export class RentalEquipmentsComponent implements OnInit {

  public menuBreadCrumb: Array<MenuBreadCrumb> = [
    {
      name: "Inicio",
      router: '/inicio',
    },
    {
      name: "Equipos de Alquiler",
      current: true
    },
  ]
  public urlTableInventoryEquipment: string = `${EndpointDictionary.EquipmentRental.EQUIPMENT_RENTAL_TABLE}`;
  public reloadTableInventoryEquipment = new EventEmitter<any>();

  public configurationInentoryEquipment: TableConfiguration = {
    edit: true,
    primaryKey: 'equipmentId',
    hideTitle: true
  };

  public columnasInventoryEquipment: TableColumns<EquipmentRental>[] = [
    {
      ID: 'equipmentCode',
      label: 'Código',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
      disregardForEdit: true,
    },
    {
      ID: 'equipmentName',
      label: 'Marca',
      type: 'text',
      style: {
        textAlign: 'center',

      },
      disregardForEdit: true,
    },
    {
      ID: 'rentalCost',
      label: 'Costo',
      type: 'number',
      style: {
        textAlign: 'center'
      },
    },
    {
      ID: 'availabilityStatus',
      label: 'Estado',
      type: 'text',
      style: {
        textAlign: 'center',
      },
      disregardForEdit: true,
    },
    {
      ID: 'rentalOrderNumbers',
      label: 'N° Orden alquiler',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
      disregardForEdit: true,
    }
  ];

  headerFilters: Array<HeaderFilters> = [
    {
      tN: 'availabilityStatus',
      labelFilter: 'Estado',
      visibleField: 'name',
      primaryKey: 'name',
      type: 'select',
      value: '',
      data: [
        { name: 'disponible' },
        { name: 'alquilado' }
      ],
    },
  ];


  constructor(
    private http: HttpService,
    private message: MessageService
  ) { }

  ngOnInit(): void {
  }

  async editCost($event: UpdateData<EquipmentRental>) {
    let form: EquipmentRental = {
      rentalCost: $event.new.rentalCost as number,
      equipmentId: $event.old.equipmentId
    };
    this.message.openLoading('Cargando', 'Actualizando');
    let res = await this.http.putDataBody<GenericResponse>(EndpointDictionary.Inventory.PUT_CONST_IVENTORY_EQUIPMENT, form);
    if (res) {
      this.message.SuccessToast(res.message);
    }
    this.reloadTableInventoryEquipment.emit();
    this.message.closeLoading();
  }

}
